/* eslint-disable import/prefer-default-export */

export const ROLES = {
  AGENT: 'Agent',
  SUPER_ADMIN: 'SuperAdmin',
  SCHOOL_ADMIN: 'SchoolAdmin',
  INSTRUCTOR: 'Instructor',
  PRACTITIONER: 'Practitioner',
  STAFF: 'Staff',
  STUDENT: 'Student',
  GUARDIAN: 'Guardian',
  DEPENDENT: 'Dependent',
};
